(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaplang-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaplang-slideshow')) {
    class KaplangSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.querySelectorAll('[data-go]').forEach((b) =>
          b.addEventListener('click', () => this.go(Number(b.dataset.go), true))
        );
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => this.sync(), 60);
        }, { passive: true });
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !this.reduced) {
          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => (this.paused = true), { passive: true }));
          ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => (this.paused = false)));
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden) this.go(this.index + 1, false);
          }, Math.max(3, Number(this.dataset.speed) || 6) * 1000);
        }
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
            if (i > -1) this.go(i, true);
          });
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      go(i, user) {
        const n = this.slides.length;
        i = ((i % n) + n) % n;
        if (user) this.paused = true;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: this.reduced ? 'auto' : 'smooth' });
        this.set(i);
      }
      sync() {
        const w = this.track.clientWidth || 1;
        this.set(Math.round(this.track.scrollLeft / w));
      }
      set(i) {
        this.index = i;
        this.querySelectorAll('[data-go]').forEach((b) =>
          b.setAttribute('aria-current', Number(b.dataset.go) === i ? 'true' : 'false')
        );
      }
    }
    customElements.define('kaplang-slideshow', KaplangSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaplang-home-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaplang-routine')) {
    class KaplangRoutine extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        this.prev?.addEventListener('click', () => this.page(-1));
        this.next?.addEventListener('click', () => this.page(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update());
        this.update();
      }
      page(dir) {
        const item = this.track.querySelector('li');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perView = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: dir * step * perView });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('kaplang-routine', KaplangRoutine);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
